// test1946
(1946 && 0);
